// THIS IS AN AUTOGENERATED FILE. DO NOT MODIFY.
import { createIcon } from './utils/createIcon';

export const VerticalBars = createIcon(
  <path
    clipRule="evenodd"
    d="M11.9752 5.33447C12.4723 5.33447 12.8752 5.73742 12.8752 6.23447V18.7652H11.0752V6.23447C11.0752 5.73742 11.4781 5.33447 11.9752 5.33447ZM7.5001 7.29248C7.99715 7.29248 8.4001 7.69542 8.4001 8.19248V18.7653H6.6001V8.19248C6.6001 7.69542 7.00304 7.29248 7.5001 7.29248ZM17.4001 12.5001C17.4001 12.003 16.9972 11.6001 16.5001 11.6001C16.003 11.6001 15.6001 12.003 15.6001 12.5001V18.7655H17.4001V12.5001Z"
    fillRule="evenodd"
  />,
);
